
<script context="module">

export const CLIENT_MSG = Object.freeze({
    getCanvasState: 5,
    strokeMessage: 6,
})

</script>